import React, { useState, useEffect } from 'react';
import { Controller } from 'react-hook-form';
import { Autocomplete } from '@mui/material';
import { FormHelperText, InputLabel, TextField } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { withStyles } from '@mui/styles';
import { LabelWithToolTip } from 'components';
import { LabelLine } from 'components/InputV2/components';
import { getBusiness } from './services/BusinessAccountsServices';
import { useStyles } from './style';

const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(1),
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input': {
      padding: '1.5px 4px',
    },
    '& .MuiInputLabel-formControl': {
      top: '-7px',
      color: '#546e7a',
      fontSize: '12px',
    },
    '& .MuiInputAdornment-root': { color: '#546e7a' },
  },
}))(TextField);

const BusinessAccounts = ({ errors, control, name, label, required = false, tooltip }) => {
  const classes = useStyles();

  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const result = await getBusiness();
        setLoading(false);

        let data = result.result;

        data = data?.guilds;
        if (data) {
          let list = [];
          list = data.map((val) => ({
            name: val.name,
            code: val.code,
          }));

          setList(list);
        }
      } catch (error) {
      }
    })();
  }, []);

  return (
    <Controller
      name={name}
      render={({ field: { onChange, value } }) => (
        <Autocomplete
          selectOnFocus
          onChange={(event, newValue) => {
            onChange(newValue);
          }}
          id={name}
          isOptionEqualToValue={(option, value) => option.code === value.code}
          getOptionLabel={(option) => option.name}
          options={list}
          value={value}
          filterSelectedOptions
          loading={loading}
          renderInput={(params) => (
            <>
              <InputLabel shrink htmlFor={params?.name} className={classes.label}>
                <LabelLine
                  label={<LabelWithToolTip label={label} description={tooltip} />}
                  required={required}
                />
              </InputLabel>
              <BootstrapInput
                {...params}
                variant="outlined"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loading && <CircularProgress color="inherit" size={20} />}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
              <FormHelperText id="my-helper-text" className={classes.asterisk}>
                {errors?.[name]?.message}
              </FormHelperText>
            </>
          )}
        />
      )}
      control={control}
      rules={{
        required: 'فیلد حساب های تفصیلی الزامی است.',
      }}
      defaultValue={null}
    />
  );
};

export default BusinessAccounts;
